var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import FormDomainService from "../Domain/Form/Form.service";
import FormLiteDomainService from "../Domain/FormLite/FormLite.service";
const BASE_URL = "/aviso/form";
export default class FormService {
    static createForm(formCreateRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_URL + "/create", formCreateRequest).then(FormDomainService.fromJSON);
        });
    }
    static search(search, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const form = yield FetchService.getPagedResponse(BASE_URL + "/search", {
                ids: search.ids,
                titles: search.titles,
                formTypeIds: search.formTypeIds,
                modifiedByIds: search.modifiedByIds,
                createdByIds: search.createdByIds,
                searchText: search.searchText,
                modifiedDateTo: search.modifiedDateTo,
                modifiedDateFrom: search.modifiedDateFrom,
                createdDateTo: search.createdDateTo,
                createdDateFrom: search.createdDateFrom,
                orderBy: search.orderBy,
                active: search.active,
                max: options === null || options === void 0 ? void 0 : options.max,
                offset: options === null || options === void 0 ? void 0 : options.offset,
                sort: options === null || options === void 0 ? void 0 : options.sort,
                order: options === null || options === void 0 ? void 0 : options.order,
                query: search === null || search === void 0 ? void 0 : search.query,
            });
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            return Object.assign(Object.assign({}, form), { data: form.data.map(FormLiteDomainService.fromJSON) });
        });
    }
    static get(formId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse(BASE_URL + "/get", {
                formId,
            }).then(FormDomainService.fromJSON);
        });
    }
    static editForm(formEditRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_URL + "/editForm", formEditRequest).then(FormDomainService.fromJSON);
        });
    }
    static activate(formId) {
        return FetchService.postSingleResponse(BASE_URL + "/activate", {
            formId,
        }).then(FormDomainService.fromJSON);
    }
}
